import { Transaction } from "src/interfaces";

import { asDate } from "./date";

export function mapTransactionFromPayload(payload: any): Transaction {
  return {
    ...payload,
    date: asDate(payload?.date),
  };
}
